import { useParams } from 'react-router'

import { PersistentStateContextValue } from 'directFlow/state/persistentState/PersistentStateManager'
import { FlowContext, useFlowContext } from 'directFlow/utils/FlowContext'

import { VehicleType } from 'types'
import { useGetQuoteV2Query } from 'app/services'

export const useShouldShowPreviousInsuranceCancelled = (
  persistentState?: PersistentStateContextValue,
) => {
  const { quoteId } = useParams<{ quoteId: string }>()

  if (!quoteId) {
    throw new Error(
      'useShouldShowPreviousInsuranceCancelled was used on a route without a quote ID',
    )
  }

  const flowContext = useFlowContext()
  const {
    data: quoteData,
    isLoading: isQuoteLoading,
    isError: isQuoteError,
  } = useGetQuoteV2Query({ quoteId }, { skip: flowContext === FlowContext.DIRECT })

  const isVan =
    persistentState &&
    persistentState.stateRef.current?.pageState?.vehicleFound?.vehicleType === VehicleType.VAN

  const showPreviousInsuranceCancelled = (() => {
    if (isQuoteLoading || isQuoteError) return false

    // if VAN, always return false
    if (quoteData?.vehicle?.vehicleType === VehicleType.VAN || isVan) {
      return false
    }

    // default to true
    return true
  })()

  return {
    showPreviousInsuranceCancelled,
    isQuoteLoading,
    isQuoteError,
    quoteData,
  }
}
